module.exports = "/_next/static/images/newYorkTimes-96184ca9197d54e4c5a70e895b888018.png";